import { AxiosError } from 'axios';
import { StepperContextData } from '../contexts';
import { RingtercomFeature, RingtercomVersion } from '../utils/constants';
import { NamingConvention, SupportType } from './getModels';
import idsAxios from './idsAxios';
import { isMultidoor } from './utils';

export interface Candidate {
  model_name: string;
  support: SupportType;
  ring_to_open?: boolean;
  has_video?: boolean;
  terminal_labels: string[];
  hw_version?: RingtercomVersion;
  backplate_number?: string;
}

export interface ModelsListResponse {
  candidates: Candidate[];
  estimated_support_status: SupportType;
  support_by_hw_version?: {
    [key in RingtercomVersion]: { [key in RingtercomFeature]: SupportType };
  };
}

const listModels = async (
  brandName: string,
  terminals: NamingConvention[],
  multiDoor: boolean,
  isParallel: boolean,
  hasVideo: boolean
) => {
  const requestOptions = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const multidoor = isMultidoor({
      isParallel,
      multiDoor,
    } as StepperContextData);
    const response = await idsAxios.post(
      `/brands/${brandName}/identify_model`,
      JSON.stringify({
        terminal_labels: terminals,
        multidoor,
        has_video: hasVideo,
      }),
      requestOptions
    );

    return response.data as ModelsListResponse;
  } catch (error) {
    const message = (error as AxiosError)?.message || undefined;
    const code = (error as AxiosError)?.code || undefined;
    throw new AxiosError(message, code);
  }
};
export default listModels;
